import './App.css';
import { Box } from "@mui/material"
import { createTheme } from '@mui/material/styles'
import { ThemeProvider } from '@emotion/react';
import ValueProposition from './components/ValueProposition';
import Products from './components/Products';
import AboutUs from './components/AboutUs';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar/Navbar';
import Home from './components/Home';


const theme = createTheme({
  typography: {
    fontFamily: 'Arial, Helvetica, sans-serif'
  },
});

const App = () => {
  return (
    <ThemeProvider theme= {theme}>      
      <Box>
        <Navbar/>
        <Home/>
        <ValueProposition/>
        <Products/>
        <AboutUs/>
        <Contact/>
        <Footer/>
      </Box>
      </ThemeProvider>    
  );
}

export default App;

